/**
 * コンストラクターの引数としてnever型以外の値を指定して呼び出すと
 * TypeScriptでコンパイルエラーとなるクラス。
 *
 * このクラス自体は何もできないクラスだが、switchのdefaultでthrowすることで
 * 「defaultの前までで全ての条件を網羅していない限りコンパイルが通らない」
 * のような動きを実現できる。
 *
 * @example
 * ```typescript
 * const value1: "a" | "b" = getValue1();
 * switch (value1) {
 *     case "a": {
 *         doSomething1(value1);
 *         break;
 *     }
 *     case "b": {
 *         doSomething2(value1);
 *         break;
 *     }
 *     default: {
 *         // 全ての分岐が網羅されているためコンパイルが通る。
 *         // (型で嘘をついていないなら)絶対に到達しない分岐となる。
 *         throw new ExhaustiveError(value1);
 *     }
 * }
 *
 * const value2: "a" | "b" | "c" = getValue2();
 * switch (value2) {
 *     case "a": {
 *         doSomething1(value2);
 *         break;
 *     }
 *     case "b": {
 *         doSomething2(value2);
 *         break;
 *     }
 *     default: {
 *         // "c"が分岐網羅されていないためコンパイルエラーになる。
 *         // case "c"を適切に付け加えることでコンパイルが通るようになる。
 *         throw new ExhaustiveError(value2);
 *     }
 * }
 * ```
 *
 */
export class ExhaustiveError extends Error {
    constructor(value: never) {
        super(`not exhaustive. value: ${value}`);
        this.name = "ExhaustiveError";
    }
}
